
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"44","height":"44","viewBox":"0 0 44 44","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M24.676 37.015h-13.34a3.334 3.334 0 01-3.334-3.335V10.337a3.334 3.334 0 013.335-3.335h21.676a3.334 3.334 0 013.334 3.335V18.5M16 14h12M16 20h9","stroke":"#363636","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M20.334 27.252l-.345.757h-4.712l.28-.757h4.777zm-.657 1.467l-.366.767h-4.034l.28-.767h4.12zm1.552-3.402l-.497 1.058a3.428 3.428 0 00-.387-.263 2.402 2.402 0 00-.48-.213 1.857 1.857 0 00-.575-.085c-.353 0-.664.093-.934.28-.27.185-.482.467-.636.846-.151.376-.227.853-.227 1.43 0 .578.076 1.055.227 1.432.154.376.366.656.636.838.27.182.581.273.934.273.208 0 .4-.027.575-.081.175-.055.333-.123.472-.206.142-.083.264-.166.366-.249l.504 1.058c-.253.22-.545.386-.877.498-.329.11-.676.166-1.04.166-.606 0-1.144-.147-1.612-.443-.467-.299-.833-.726-1.098-1.282-.265-.56-.397-1.227-.397-2.003 0-.78.132-1.448.397-2.007.265-.558.631-.987 1.098-1.285.468-.3 1.006-.451 1.612-.451a3 3 0 011.939.689z","fill":"#363636"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M32.664 26.724c3.827 0 7.08-1.968 8.33-4.724v.839c0 5.011-3.683 9.099-8.33 9.405v3.917L26 29.497l6.664-6.664v3.888","fill":"#F9B621"}}),_c('path',{attrs:{"d":"M32.664 26.724c3.827 0 7.08-1.968 8.33-4.724v.839c0 5.011-3.683 9.099-8.33 9.405v3.917L26 29.497l6.664-6.664v3.888","stroke":"#363636","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    